import React from 'react';
import FilterItem from '../FilterItem/FilterItem';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import './TextInputFilter.css';

const TextInputFilter = ({
    filterName,
    displayName,
    isActive,
    selectedItems,
    inputValue,
    onToggle,
    onInputChange,
    onInputSubmit,
    onRemoveTag,
    onClear
}) => {
    const handleApply = () => {
        onToggle(null);
    };

    return (
        <FilterItem
            label={displayName}
            isActive={isActive}
            hasFilters={selectedItems.length > 0}
            count={selectedItems.length}
            onToggle={() => onToggle(filterName)}
        >
            <DropdownMenu
                title={displayName}
                hasSelectedItems={selectedItems.length > 0}
                onClear={() => onClear(filterName)}
                onApply={handleApply}
            >
                <div className="text-input-field">
                    <input
                        type="text"
                        className="text-input"
                        placeholder="Saisissez un texte de loi et appuyez sur Entrée"
                        value={inputValue}
                        onChange={(e) => onInputChange(filterName, e.target.value)}
                        onKeyDown={(e) => onInputSubmit(filterName, e)}
                    />

                    <div className="text-tag-container">
                        {selectedItems.map(item => (
                            <div key={item} className="text-tag">
                                {item}
                                <span
                                    className="text-tag-remove"
                                    onClick={() => onRemoveTag(filterName, item)}
                                >
                                    ×
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </DropdownMenu>
        </FilterItem>
    );
};

export default TextInputFilter;